/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleADownIcon24Regular = forwardRef('ArrowShapeTriangleADownIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.564 5.25c1.386 0 2.222 1.535 1.47 2.7L13.47 18.107a1.75 1.75 0 0 1-2.94 0L3.967 7.95c-.752-1.165.084-2.7 1.47-2.7h13.127Zm.21 1.886a.25.25 0 0 0-.21-.386H5.437a.25.25 0 0 0-.21.386l6.563 10.157a.25.25 0 0 0 .42 0l6.563-10.157Z" })));
});
